
import React from 'react';
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { 
  User, 
  LogOut, 
  Settings, 
  ChevronDown,
  LayoutDashboard
} from 'lucide-react';
import { Link } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export const TopMenuBar = () => {
  const { user, profile, signOut, hasAdminAccess } = useAuth();

  const handleSignOut = async () => {
    try {
      await signOut();
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  // Check if user is Super Admin or Admin
  const isSuperAdminOrAdmin = profile?.role && ['super_admin', 'admin'].includes(profile.role);

  return (
    <div className="w-full bg-blue-700 text-white text-sm fixed top-0 left-0 right-0 z-40 hidden lg:block border-b border-blue-800 [content-visibility:auto] [contain-intrinsic-size:1px_44px]">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-end h-11">
          {/* Right side - Authentication */}
          <div className="flex items-center space-x-2">
            {user ? (
              <div className="flex items-center space-x-2">
                {/* Dashboard button for Super Admin and Admin only */}
                {isSuperAdminOrAdmin && (
                  <Link to="/admin">
                    <Button variant="ghost" size="sm" className="text-white hover:bg-blue-800 h-11 px-3">
                      <LayoutDashboard className="h-3 w-3 mr-1" />
                      Dashboard
                    </Button>
                  </Link>
                )}
                
                <DropdownMenu>
                  <DropdownMenuTrigger asChild>
                    <Button variant="ghost" size="sm" className="text-white hover:bg-blue-800 h-11 px-3">
                      <User className="h-3 w-3 mr-1" />
                      {profile?.first_name || user.email}
                      {profile?.role && (
                        <Badge variant="secondary" className="ml-2 text-xs bg-blue-900 text-white">
                          {profile.role}
                        </Badge>
                      )}
                      <ChevronDown className="h-3 w-3 ml-1" />
                    </Button>
                  </DropdownMenuTrigger>
                  <DropdownMenuContent align="end" className="z-[250] bg-popover text-popover-foreground">
                    <DropdownMenuItem asChild>
                      <Link to="/profile" className="flex items-center">
                        <User className="h-4 w-4 mr-2" />
                        Profile
                      </Link>
                    </DropdownMenuItem>
                    {hasAdminAccess && (
                      <DropdownMenuItem asChild>
                        <Link to="/admin" className="flex items-center">
                          <Settings className="h-4 w-4 mr-2" />
                          Settings
                        </Link>
                      </DropdownMenuItem>
                    )}
                    <DropdownMenuSeparator />
                    <DropdownMenuItem onClick={handleSignOut} className="flex items-center">
                      <LogOut className="h-4 w-4 mr-2" />
                      Sign Out
                    </DropdownMenuItem>
                  </DropdownMenuContent>
                </DropdownMenu>
              </div>
            ) : (
              <div className="flex items-center space-x-2">
                <Link to="/auth">
                  <Button variant="ghost" size="sm" className="text-white hover:bg-blue-800 h-11 px-3">
                    <User className="h-3 w-3 mr-1" />
                    Sign In
                  </Button>
                </Link>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
